module.exports = __webpack_public_path__ + "img/parallax2-850p.786b67c7.jpg";